import defaultQuestions from "./scope_sheet_questions.json";

let stylesInjected = false;
let clicked = false;
let scopeSheetInitialized = false;
let retryCount = 0;
let formRef = null;
let overlayRef = null;
let questionsRef = null;
console.log("[ScopeSheet] file loaded");

function deepClone(obj) {
  console.log("[ScopeSheet] deepClone");
  return JSON.parse(JSON.stringify(obj));
}

function injectStyles() {
  if (stylesInjected) return;
  console.log("[ScopeSheet] injecting styles");
  stylesInjected = true;
  const style = document.createElement("style");
  style.innerHTML = `
  .ssButton { font-style: italic; color: blue; cursor: pointer; text-decoration: none; }
  .ssButton:hover { opacity: 70%; }
  #dynamicForm {
      display: none;
      flex-direction: column;
      align-items: stretch;
      position: fixed;
      top: 4%;
      right: 5%;
      left: 5%;
      width: 90%;
      max-width: 900px;
      max-height: 90vh;
      background-color: #f9f9f9;
      border: 1px solid #ddd;
      border-radius: 10px;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
      overflow-y: auto;
      padding: 28px 28px 96px;
      box-sizing: border-box;
      margin: 0 auto;
      z-index: 1000;
  }
  #overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.55);
      z-index: 999;
  }
  #dynamicForm.is-open { display: flex; }
  #overlay.is-open { display: block; }
  #xButton {
      color: red;
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 36px;
      cursor: pointer;
  }
  #finishButton {
      background-color: #007BFF;
      color: white;
      border-radius: 4px;
      text-transform: uppercase;
      margin: 24px auto 12px;
      padding: 8px 16px;
      font-size: 24px;
      cursor: pointer;
      display: block;
      max-width: 320px;
      width: 100%;
  }
  #finishButton:hover { opacity: 75%; }
  #dynamicForm > div {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 16px;
      border-bottom: 2px solid #ddd;
  }
  #dynamicForm > div:last-child {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 16px;
      border: none;
  }
  #dynamicForm h3 { margin-bottom: 8px; }
  #dynamicForm label {
      display: block;
      margin-bottom: 8px;
      font-weight: bold;
  }
  #dynamicForm input[type="text"],
  #dynamicForm input[type="date"],
  #dynamicForm select,
  #dynamicForm input[type="checkbox"],
  input[type="datetime-local"] {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 8px;
      margin-bottom: 12px;
      width: 100%;
      box-sizing: border-box;
  }
  #dynamicForm input[type="checkbox"] { height: 20px; width: 20px; }
  #addRoomButton {
      display: block;
      margin: 24px auto 0;
      padding: 12px 24px;
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
      text-align: center;
  }
  #addRoomButton:hover { background-color: #0056b3; }
  .deleteRoomButton {
    display: block;
    margin: 24px auto 0;
    padding: 12px 24px;
    background-color: red;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    text-align: center;
  }
  .deleteRoomButton:hover { opacity: 75%; }
  #dynamicForm div div {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;
      justify-content: space-between;
      align-items: flex-start;
  }
  `;
  document.head.appendChild(style);
}

// Legacy inline handlers
window.estimateValue = function() { clicked = true; };
window.setDisabledOff = function() {
  const elements = document.getElementsByName("commit");
  const hiddenInput = document.getElementById("scopeSheetsResponsesInput");
  const scopeSheetCheckbox = document.getElementById("scope_sheets");
  if (!elements || !elements.length) return;
  const enabled = (hiddenInput && hiddenInput.value !== "" || (scopeSheetCheckbox && scopeSheetCheckbox.checked)) && clicked;
  elements[0].disabled = !enabled;
};

function extractRooms(data) {
  if (!data || !data.Equipment) return [];
  if (data.Equipment.rooms && data.Equipment.rooms.value) {
    return Object.keys(data.Equipment.rooms.value || {})
      .filter(k => k.startsWith("room-"))
      .map(k => data.Equipment.rooms.value[k]);
  }
  return Object.keys(data.Equipment)
    .filter(k => k.startsWith("room-"))
    .map(k => data.Equipment[k]);
}

function getRoomValue(roomData, key) {
  if (!roomData) return "";
  if (roomData[key]) return roomData[key].value || roomData[key] || "";
  const altKey = Object.keys(roomData).find(k => k.startsWith(key));
  return altKey && roomData[altKey] ? (roomData[altKey].value || roomData[altKey] || "") : "";
}

function createFormElement(key, item) {
  const label = document.createElement("label");
  label.textContent = item.label || "No label";
  label.setAttribute("for", key);

  let input;
  switch (item.type) {
    case "boolean":
      input = document.createElement("input");
      input.type = "checkbox";
      input.checked = item.value || false;
      break;
    case "date":
      input = document.createElement("input");
      input.type = "date";
      input.value = item.value || "";
      break;
    case "dropdown":
      input = document.createElement("select");
      if (Array.isArray(item.options)) {
        item.options.forEach(option => {
          const optionElement = document.createElement("option");
          optionElement.value = option;
          optionElement.textContent = option;
          if (option === item.value) optionElement.selected = true;
          input.appendChild(optionElement);
        });
      }
      break;
    default:
      input = document.createElement("input");
      input.type = "text";
      input.value = item.value || "";
  }

  if (input) input.id = key;
  const questionDiv = document.createElement("div");
  questionDiv.appendChild(label);
  questionDiv.appendChild(input);
  return questionDiv;
}

function buildRoomSection(roomNumber, roomData) {
  const roomSection = document.createElement("div");
  roomSection.classList.add("room-section");
  roomSection.innerHTML = `
      <h3>Room ${roomNumber}</h3>
      <label for="roomName${roomNumber}">Room Name:</label>
      <input type="text" id="roomName${roomNumber}" name="roomName${roomNumber}"><br>
      <label for="numberOfDehus${roomNumber}">Number of Dehus:</label>
      <input type="number" id="numberOfDehus${roomNumber}" name="numberOfDehus${roomNumber}"><br>
      <label for="dehuSize${roomNumber}">Dehu Size:</label>
      <input type="text" id="dehuSize${roomNumber}" name="dehuSize${roomNumber}"><br>
      <label for="datesInUseDehus${roomNumber}">Dates in Use (Dehus):</label>
      <input type="text" id="datesInUseDehus${roomNumber}" name="datesInUseDehus${roomNumber}"><br>
      <label for="numberOfAirMovers${roomNumber}">Number of Air Movers:</label>
      <input type="number" id="numberOfAirMovers${roomNumber}" name="numberOfAirMovers${roomNumber}"><br>
      <label for="airMoverType${roomNumber}">Air Mover Type:</label>
      <input type="text" id="airMoverType${roomNumber}" name="airMoverType${roomNumber}"><br>
      <label for="datesInUseAirMovers${roomNumber}">Dates in Use (Air Movers):</label>
      <input type="text" id="datesInUseAirMovers${roomNumber}" name="datesInUseAirMovers${roomNumber}"><br>
      <label for="numberOfAirScrubbers${roomNumber}">Number of Air Scrubbers:</label>
      <input type="number" id="numberOfAirScrubbers${roomNumber}" name="numberOfAirScrubbers${roomNumber}"><br>
      <label for="airScrubberSize${roomNumber}">Air Scrubber Size:</label>
      <input type="text" id="airScrubberSize${roomNumber}" name="airScrubberSize${roomNumber}"><br>
      <label for="datesInUseAirScrubbers${roomNumber}">Dates in Use (Air Scrubbers):</label>
      <input type="text" id="datesInUseAirScrubbers${roomNumber}" name="datesInUseAirScrubbers${roomNumber}"><br>
      <label for="heatDryingEquipment${roomNumber}">Heat Drying Equipment Type:</label>
      <input type="text" id="heatDryingEquipment${roomNumber}" name="heatDryingEquipment${roomNumber}"><br>
      <label for="datesInUseHeatDrying${roomNumber}">Dates in Use (Heat Drying):</label>
      <input type="text" id="datesInUseHeatDrying${roomNumber}" name="datesInUseHeatDrying${roomNumber}"><br>
      <label for="floorMatDryingSystem${roomNumber}">Floor Mat Drying System # of Units:</label>
      <input type="number" id="floorMatDryingSystem${roomNumber}" name="floorMatDryingSystem${roomNumber}"><br>
      <label for="datesInUseFloorMat${roomNumber}">Dates in Use (Floor Mat):</label>
      <input type="text" id="datesInUseFloorMat${roomNumber}" name="datesInUseFloorMat${roomNumber}"><br>
      <label for="containmentBarrierPlastic${roomNumber}">Containment Barrier & Poles Square Footage of Plastic Used:</label>
      <input type="text" id="containmentBarrierPlastic${roomNumber}" name="containmentBarrierPlastic${roomNumber}"><br>
      <label for="numberOfPoles${roomNumber}">Number of Poles:</label>
      <input type="number" id="numberOfPoles${roomNumber}" name="numberOfPoles${roomNumber}"><br>
      <label for="datesInUseContainment${roomNumber}">Dates in Use (Containment):</label>
      <input type="text" id="datesInUseContainment${roomNumber}" name="datesInUseContainment${roomNumber}"><br>
      <label for="zipper${roomNumber}">Zipper? (Y/N):</label>
      <input type="text" id="zipper${roomNumber}" name="zipper${roomNumber}"><br>
      <label for="heavyDuty${roomNumber}">Heavy Duty? (Y/N):</label>
      <input type="text" id="heavyDuty${roomNumber}" name="heavyDuty${roomNumber}"><br>
      <label for="containmentFilter${roomNumber}">Containment Filter? (Y/N):</label>
      <input type="text" id="containmentFilter${roomNumber}" name="containmentFilter${roomNumber}"><br>
      <label for="specialtyEquipmentType${roomNumber}">Other Specialty Equipment Type:</label>
      <input type="text" id="specialtyEquipmentType${roomNumber}" name="specialtyEquipmentType${roomNumber}"><br>
      <label for="numberOfSpecialtyUnits${roomNumber}"># of Units:</label>
      <input type="number" id="numberOfSpecialtyUnits${roomNumber}" name="numberOfSpecialtyUnits${roomNumber}"><br>
      <label for="datesInUseSpecialty${roomNumber}">Dates in Use (Specialty Equipment):</label>
      <input type="text" id="datesInUseSpecialty${roomNumber}" name="datesInUseSpecialty${roomNumber}"><br>
      <button type="button" class="deleteRoomButton">Delete Room</button>
  `;

  if (roomData) {
    const inputs = roomSection.querySelectorAll("input");
    inputs.forEach((input) => {
      const baseKey = input.id.replace(/\d+$/, "");
      input.value = getRoomValue(roomData, input.id) || getRoomValue(roomData, baseKey);
    });
  }

  const deleteButton = roomSection.querySelector(".deleteRoomButton");
  deleteButton.addEventListener("click", () => {
    roomSection.remove();
  });

  return roomSection;
}

function processObject(obj, container) {
  Object.keys(obj).forEach((key) => {
    const item = obj[key];
    if (item && typeof item === "object" && (item.type || item.label || item.value)) {
      const questionDiv = createFormElement(key, item);
      if (questionDiv) container.appendChild(questionDiv);
      Object.keys(item).forEach((nestedKey) => {
        if (["type", "label", "value", "options"].includes(nestedKey)) return;
        const nestedItem = item[nestedKey];
        if (nestedItem && typeof nestedItem === "object") {
          const nestedQuestionDiv = createFormElement(nestedKey, nestedItem);
          if (nestedQuestionDiv) container.appendChild(nestedQuestionDiv);
        }
      });
    } else if (item && typeof item === "object") {
      const sectionDiv = document.createElement("div");
      const sectionTitle = document.createElement("h3");
      sectionTitle.textContent = key;
      sectionDiv.appendChild(sectionTitle);
      const nestedForm = document.createElement("form");
      processObject(item, nestedForm);
      sectionDiv.appendChild(nestedForm);
      container.appendChild(sectionDiv);
    }
  });
}

function buildForm(questions) {
  const form = document.createElement("form");
  form.id = "dynamicForm";
  const xButton = document.createElement("button");
  xButton.id = "xButton";
  xButton.type = "button";
  xButton.innerHTML = "x";
  const finishButton = document.createElement("button");
  finishButton.id = "finishButton";
  finishButton.type = "button";
  finishButton.innerHTML = "Submit";

  form.appendChild(xButton);

  let equipmentSectionName;
  const sections = [];
  Object.keys(questions).forEach((sectionName) => {
    const sectionData = questions[sectionName];
    if (sectionName === "Equipment") equipmentSectionName = sectionName;
    const sectionDiv = document.createElement("div");
    const sectionTitle = document.createElement("h2");
    sectionTitle.textContent = sectionName;
    sectionDiv.appendChild(sectionTitle);
    processObject(sectionData, sectionDiv);
    sections.push({ title: sectionName, element: sectionDiv });
  });

  sections.forEach((section) => {
    form.appendChild(section.element);
    if (section.title === equipmentSectionName) {
      const roomsSectionDiv = document.createElement("div");
      roomsSectionDiv.id = "roomsSection";
      const roomsTitle = document.createElement("h2");
      roomsTitle.textContent = "Rooms";
      roomsSectionDiv.appendChild(roomsTitle);

      const addRoomButton = document.createElement("button");
      addRoomButton.type = "button";
      addRoomButton.id = "addRoomButton";
      addRoomButton.textContent = "Add Room";

      const roomsContainer = document.createElement("div");
      roomsContainer.id = "roomsContainer";

      const existingRooms = extractRooms(questions);
      existingRooms.forEach((roomData, idx) => roomsContainer.appendChild(buildRoomSection(idx + 1, roomData)));

      addRoomButton.onclick = () => {
        const count = roomsContainer.querySelectorAll(".room-section").length + 1;
        roomsContainer.appendChild(buildRoomSection(count, null));
      };

      roomsSectionDiv.appendChild(addRoomButton);
      roomsSectionDiv.appendChild(roomsContainer);
      form.appendChild(roomsSectionDiv);
    }
  });

  form.appendChild(finishButton);

  return { form, xButton, finishButton };
}

function updateJsonWithFormValues(questions, form) {
  Object.keys(questions).forEach((section) => {
    const fields = questions[section];
    Object.keys(fields).forEach((key) => {
      const field = fields[key];
      const inputElement = form.querySelector(`#${key}`);
      if (inputElement && field && typeof field === "object") {
        if (field.type === "boolean") {
          field.value = inputElement.checked;
        } else {
          field.value = inputElement.value;
        }
      }
      if (field && typeof field === "object") {
        Object.keys(field).forEach((nestedKey) => {
          const nestedField = field[nestedKey];
          const nestedInputElement = form.querySelector(`#${nestedKey}`);
          if (nestedInputElement && nestedField && typeof nestedField === "object") {
            if (nestedField.type === "boolean") {
              nestedField.value = nestedInputElement.checked;
            } else {
              nestedField.value = nestedInputElement.value;
            }
          }
        });
      }
    });
  });

  const roomSections = form.querySelectorAll(".room-section");
  const roomFieldsContainer = questions.Equipment.rooms && questions.Equipment.rooms.value
    ? questions.Equipment.rooms.value
    : questions.Equipment;

  roomSections.forEach((roomSection, index) => {
    const roomKey = `room-${index + 1}`;
    const roomFields = {};
    const inputs = roomSection.querySelectorAll("input, select");

    const fieldLabels = {
      roomName: "Room Name",
      numberOfDehus: "Number of Dehus",
      dehuSize: "Dehu Size",
      datesInUseDehus: "Dates in Use (Dehus)",
      numberOfAirMovers: "Number of Air Movers",
      airMoverType: "Air Mover Type",
      datesInUseAirMovers: "Dates in Use (Air Movers)",
      numberOfAirScrubbers: "Number of Air Scrubbers",
      airScrubberSize: "Air Scrubber Size",
      datesInUseAirScrubbers: "Dates in Use (Air Scrubbers)",
      heatDryingEquipment: "Heat Drying Equipment",
      datesInUseHeatDrying: "Dates in Use (Heat Drying)",
      floorMatDryingSystem: "Floor Mat Drying System",
      datesInUseFloorMat: "Dates in Use (Floor Mat)",
      containmentBarrierPlastic: "Containment Barrier Plastic Used",
      numberOfPoles: "Number of Poles",
      datesInUseContainment: "Dates in Use (Containment)",
      zipper: "Zipper? (Y/N)",
      heavyDuty: "Heavy Duty? (Y/N)",
      containmentFilter: "Containment Filter? (Y/N)",
      specialtyEquipmentType: "Specialty Equipment Type",
      numberOfSpecialtyUnits: "Number of Specialty Units",
      datesInUseSpecialty: "Dates in Use (Specialty Equipment)"
    };

    inputs.forEach((input) => {
      const key = input.id;
      let value;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
      const baseKey = key.replace(/\d+$/, "");
      const field = roomFields[key] || {};
      if (input.type === "checkbox") {
        field.value = value;
        field.type = "boolean";
      } else if (input.type === "date") {
        field.value = value;
        field.type = "date";
      } else {
        field.value = value;
        field.type = "text";
      }
      field.label = fieldLabels[baseKey] || "Unknown Label";
      roomFields[key] = field;
    });

    roomFieldsContainer[roomKey] = roomFields;
  });
}

function ensureBuilt() {
  console.log("[ScopeSheet] ensureBuilt start", { formRef: !!formRef, overlayRef: !!overlayRef, questionsRef: !!questionsRef });
  if (formRef && overlayRef && questionsRef) return;

  overlayRef = document.getElementById("overlay");
  if (!overlayRef) {
    overlayRef = document.createElement("div");
    overlayRef.id = "overlay";
    document.body.appendChild(overlayRef);
  }

  const dataHolder = document.getElementById("scope-sheets-responses");
  const hiddenInput = document.getElementById("scopeSheetsResponsesInput");
  const scopeCheckbox = document.getElementById("scope_sheets");
  const initialJson = dataHolder && dataHolder.getAttribute("data-json");
  try {
    questionsRef = initialJson ? JSON.parse(initialJson) : deepClone(defaultQuestions);
  } catch (e) {
    console.warn("[ScopeSheet] parse failure, using defaults", e);
    questionsRef = deepClone(defaultQuestions);
  }
  console.log("[ScopeSheet] questions loaded", { hasDataHolder: !!dataHolder, initialJsonLength: initialJson && initialJson.length });

  const built = buildForm(questionsRef);
  formRef = built.form;
  const { xButton, finishButton } = built;
  document.body.appendChild(formRef);
  console.log("[ScopeSheet] form built and appended");

  const setHidden = () => {
    updateJsonWithFormValues(questionsRef, formRef);
    if (hiddenInput) hiddenInput.value = JSON.stringify(questionsRef);
    if (scopeCheckbox) window.setDisabledOff();
    console.log("[ScopeSheet] hidden updated");
  };

  const closeModal = () => {
    formRef.style.display = "none";
    overlayRef.style.display = "none";
  };

  window.showForm = openModal;

  if (xButton) xButton.onclick = closeModal;
  if (finishButton) finishButton.onclick = closeModal;
  overlayRef.onclick = closeModal;
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  formRef.addEventListener("change", setHidden);
  formRef.addEventListener("submit", (e) => {
    e.preventDefault();
    setHidden();
    closeModal();
  });

  setHidden();
  console.log("[ScopeSheet] ensureBuilt complete");
}

function openModal() {
  console.log("[ScopeSheet] openModal called");
  ensureBuilt();
  if (!formRef || !overlayRef) return;
  formRef.style.display = "flex";
  overlayRef.style.display = "block";
  window.scrollTo({ top: 0, behavior: "smooth" });
  console.log("[ScopeSheet] modal displayed");
}

function bootstrapScopeSheet() {
  if (window.disableScopeSheetBootstrap) {
    console.log("[ScopeSheet] bootstrap skipped via disable flag");
    return;
  }
  console.log("[ScopeSheet] bootstrap start");
  injectStyles();
  ensureBuilt();

  const triggers = Array.from(document.querySelectorAll(".ssButton"));
  if (!triggers.length) {
    if (retryCount < 10) {
      retryCount += 1;
      setTimeout(bootstrapScopeSheet, 300);
    }
    return;
  }
  if (!scopeSheetInitialized) {
    scopeSheetInitialized = true;
    console.log("[ScopeSheet] binding triggers", { count: triggers.length });
  }

  triggers.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      console.log("[ScopeSheet] trigger click");
      openModal();
    });
  });
}

document.addEventListener("DOMContentLoaded", bootstrapScopeSheet);
window.bootstrapScopeSheet = bootstrapScopeSheet;
bootstrapScopeSheet();
